import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Connected.css";

const ConnectedHero = () => {
  const navigate = useNavigate();

  return (
    <div className="connected-hero-container">
      <div className="connected-hero-title">
        Connected System
        <br />
      </div>
      <div className="connected-hero-subtitle">
        Connected Systems brings all your operational systems together,
        allowing faster communications, consistent data, and smooth
        coordination across teams.
      </div>
      <motion.button
        whileHover={{
          scale: 1.08,
          backgroundColor: "#ffffff",
          color: "#000000",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.6)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="connected-hero-button font-epilogue"
        onClick={() => navigate("/schedule-a-demo")}
      >
        Schedule a Demo
      </motion.button>
    </div>
  );
};

export default ConnectedHero;
